import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import LeadsList from './leads/LeadsList';
import translate from '../../../commonComponents/translate';
import Anchor from '../../../commonComponents/Anchor';
import GameProp from '../propTypes/gameProp';

function Leads({ t, challenge }) {
  const createURL = `/challenges/leads/create?gameId=${challenge._id}`;
  const hasStarted = moment.utc(challenge.startDate).isBefore(moment.utc());

  return (
    <div className="m-portlet__body">
      {hasStarted && (
        <div className="table-add-button">
          <Anchor
            className="btn btn-dynamic m-btn--pill m-btn--wide"
            href={createURL}
          >
            <i className="la la-plus" />
            {t('challengeDetails_newLead')}
          </Anchor>
        </div>
      )}
      <LeadsList challengeId={challenge._id} />
    </div>
  );
}

Leads.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(Leads);
